export default __webpack_public_path__ + "static/media/36I-120882_-44011_0.395f539c.jpg";